import { makeDataObjGenerator } from 'mocks/helpers'
import { WorldTennisNumberTypeEnum } from 'types/api/enums'

export const wtnHistoryDefaultData = {
  type: WorldTennisNumberTypeEnum.SINGLE,
  tennisNumber: 24.81,
  ratingDate: '2018-12-29T00:00:00.000Z',
  __typename: 'WorldTennisNumber',
}

export const createWorldTennisNumberHistoryRating = makeDataObjGenerator(wtnHistoryDefaultData)

export const getRatings = (data?: (typeof wtnHistoryDefaultData)[]) => ({
  worldTennisNumberHistory: {
    items: data || [
      createWorldTennisNumberHistoryRating(),
      createWorldTennisNumberHistoryRating({ type: WorldTennisNumberTypeEnum.DOUBLE }),
    ],
    __typename: 'WorldTennisNumberList',
  },
})
